import { makeStyles } from '@mui/styles'

// css style
export const useStyles = makeStyles({
  footerButton: {
    // backgroundColor: "transparent",
    position: 'fixed',
    width: '100%',
    bottom: 1,
    right: 0.11,
    zIndex: 2
  },
  messageBox: {
    width: '100%',
    marginTop: '2rem',
    // backgroundColor: '#4CAF50',
    backgroundColor: '#FB8C00',
    borderRadius: '4px',
    padding: 16
  },
  colBlock: {
    marginTop: '2rem',
    marginBottom: '2rem'
  },
  goToSectionButton: {
    marginTop: '1rem',
    marginBottom: '1rem',
    marginLeft: '1rem',
    float: 'right'
  }
})
